<template>
  <div id="participant-addupdate-addsubevents-dialog" class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />

    <div class="modal-body" v-else key="content-loading">
      <el-col :span="24">
        <div class="registerform-input-container">
          <div class="title">
            <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.selectService") }}</label>
            <!-- <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip> -->
          </div>
          <el-select v-model="form.additionalServiceId" clearable @clear="form.additionalServiceId = null">
            <el-option v-for="service in registerForm.additionalServices" :key="service.id" :label="service.title" :value="service.id"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="24" class="mt-2">
        <RecursiveQuestionBuilder v-for="(question, index) in availableQuestions.filter(x => x.parentAnswerId == null && x.parentQuestionId == null)" :key="question + index" :question="question" :allQuestions="questionItems" :availableQuestions="availableQuestions" :baseValidationKey="'additional-services-' + activeServiceIndex + '-questions-'" />
      </el-col>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.close") }}</el-button>
        <!-- <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> Sil</el-button>
        </el-popconfirm> -->
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import RecursiveQuestionBuilder from "../Questions.vue";
export default {
  components: { RecursiveQuestionBuilder },
  props: ["data", "registerForm", "activeServiceIndex"],
  data() {
    return {
      form: {
        id: null,
        additionalServiceId: null,
        questions: [],
        price: 0,
        currency: 0,
        taxEnabled: true,
        taxName: 0,
        taxPercentage: 0
      },
      questionItems: [],
      availableQuestions: [],
      loading: false,
      timeout: null
    };
  },
  methods: {
    save() {
      if (this.form.additionalServiceId != null) {
        this.form.price = this.registerForm.additionalServices.find(x => x.id == this.form.additionalServiceId).price;
        var payload = {
          ...this.form,
          questions: this.availableQuestions
        };
        console.log("payload", payload);
        this.$emit("addUpdate", payload);
      } else {
        if (this.$i18n.locale == "tr") this.$message.error("Hizmet seçmelisiniz.");
        else this.$message.error("You must choose a service.");
      }
    }
  },
  async created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
      this.form.price = this.registerForm.accompayingPerson.price;
      this.form.currency = this.registerForm.paymentInfo.currency;
      this.form.taxEnabled = this.registerForm.paymentInfo.taxEnabled;
      this.form.taxName = this.registerForm.paymentInfo.taxName;
      this.form.taxPercentage = this.registerForm.paymentInfo.taxPercentage;

      var res = await this.$store.dispatch("getQuestionsObject", { id: this.registerForm.id, type: 1 });
      this.questionItems = res.data.data.items;
      if (this.form.questions.length > 0) {
        this.form.questions.map(x => {
          this.questionItems.find(y => y.id == x.id).answer = x.answer;
          this.questionItems.find(y => y.id == x.id).answers = x.answers;
        });
      }
      this.availableQuestions = JSON.parse(JSON.stringify(this.questionItems.filter(x => x.parentQuestionId == null && x.parentAnswerId == null)));
      this.loading = false;
    }, 500);
  }
  //   watch: {
  //     'form.additionalServiceId': async function(value) {
  //       if (value != undefined && value != null) {
  //         console.log('consul');
  //         this.questionItems = res.data.data.items;
  //         this.availableQuestions = JSON.parse(JSON.stringify(this.questionItems));

  //         if(this.form.questions.length > 0){
  //           this.form.questions.map(x => {
  //             this.availableQuestions.find(y=> y.id == x.id ).answer = x.answer;
  //             this.availableQuestions.find(y=> y.id == x.id ).answers = x.answers;
  //           })
  //         }
  //       } else {
  //         this.questionItems = [];
  //         this.availableQuestions = [];
  //       }
  //     },
  //   },
};
</script>



// WEBPACK FOOTER //
// src/components/participants/dialog/AddAdditionalService.vue